import { FormGroup, AbstractControl } from '@angular/forms';
import * as moment from 'moment-timezone';
import * as _ from 'lodash';

import { getFieldByName } from './utils';

export const getDisableSince = (selectedDate: string): any => {
  const date = new Date(selectedDate);
  return {
    'year': date.getFullYear(),
    'month': date.getMonth() + 1,
    'day': date.getDate(),
  };
};

export const isDateAhead = (startDate: string, endDate: string): boolean => {
  return new Date(startDate) > new Date(endDate);
};

export const setDateAheadControlError = (startDateControl: AbstractControl, endDateControl: AbstractControl): void => {
  if (isDateAhead(startDateControl.value, endDateControl.value)) {
    startDateControl.setErrors({'date': true});
  }
};

export const setDateDisabledRange = (expirationDate: string, dateStartName: string, segmentsData: any, index?: number): void => {
  if (!expirationDate) { return; }
  const field = getFieldByName(dateStartName, segmentsData);
  if (_.isNil(index)) {
    _.set(field, 'disable_since', getDisableSince(expirationDate));
  } else {
    _.set(field, `disable_since.${index}`, getDisableSince(expirationDate));
  }
};

export const handleDateAheadChange = (
    dateStart: AbstractControl,
    dateStartName: string,
    selectedDate: string,
    segmentsData: any,
    index?: number,
  ): void => {
  setDateDisabledRange(selectedDate, dateStartName, segmentsData, index);
  dateStart.setErrors(
    isDateAhead(dateStart.value, selectedDate) ?
    {'date': true} :
    null
  );
};

export const formatDate = (
  date: string,
  withYear: boolean = true,
  now: Date = new Date(),
  isSpecialSame: boolean = true,
  timezone: any = moment.tz.guess()
) => {
  try {
    const dateUTC = moment.tz(date, 'UTC');
    const dateTZ = dateUTC.tz(timezone);
    const nowTZ = moment(now).tz(timezone);

    if (dateTZ.isSame(nowTZ, 'day') && isSpecialSame) {
      return dateTZ.format('hh:mm A');
    }
    if (!withYear) {
      return dateTZ.format('MMMM DD');
    }
    return dateTZ.format('MMMM DD, YYYY');
  } catch (e) {
    return date;
  }
};

export const currentMomentString = () => {
  const dateUTC = moment.tz(new Date(), 'UTC');
  return dateUTC.format('YYYYMMDDHHmmssSSS');
};
